import { IconGift, COLOR_INFO_50, BadgeInfo } from '@consumidor-positivo/aurora';

type TagProps = {
  text?: string;
  type?: TypeTag;
};

type TypesTag = Record<
  TypeTag,
  {
    text: string;
    icon: string | JSX.Element;
    status: 'info' | 'success';
  }
>;

type TypeTag = 'approved' | 'default';

export const Tag = ({ text = '', type = 'default' }: TagProps) => {
  const types: TypesTag = {
    approved: {
      text: 'Chance alta de aprovação',
      status: 'success',
      icon: (
        <span role="img" aria-label="Emoji de fogo" style={{ fontSize: '14px', paddingBottom: '2px' }}>
          🔥
        </span>
      ),
    },
    default: {
      text: text,
      status: 'info',
      icon: <IconGift rawColor={COLOR_INFO_50} size="small" />,
    },
  };

  return (
    <BadgeInfo
      text={types[type].text}
      status={types[type].status}
      customIcon={types[type].icon}
    />
  );
};
